export enum RedemptionOfferingType {
    Reward = 'Reward',
    Donation = 'Donation',
    Contribution = 'Contribution',
    Store = 'Store',
    GlobalMerchandiseStore = 'GlobalMerchandiseStore',
    Bank = 'Bank',
    Other = 'Other'
}
